import { useTranslation } from 'react-i18next';

import { cn } from '@nucleus-commerce/ui/lib/utils';

/** Static pages in `public/legal`, generated from the backend's `docs/legal`; the platform app links to the same files. */
export const LEGAL_DOCUMENTS = {
  terms: '/legal/terms.html',
  privacy: '/legal/privacy.html',
  dpa: '/legal/dpa.html',
} as const;

export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation('common');
  return (
    <nav
      aria-label={t('legal.nav')}
      className={cn('flex flex-wrap justify-center gap-4', className)}
    >
      <a href={LEGAL_DOCUMENTS.terms} target="_blank" rel="noreferrer">
        {t('legal.terms')}
      </a>
      <a href={LEGAL_DOCUMENTS.privacy} target="_blank" rel="noreferrer">
        {t('legal.privacy')}
      </a>
      <a href={LEGAL_DOCUMENTS.dpa} target="_blank" rel="noreferrer">
        {t('legal.dpa')}
      </a>
    </nav>
  );
}
